import type { Breadcrumb } from './types';
import { sanitizeBreadcrumbData, truncate } from './sanitize';

const MAX_BREADCRUMBS = 30;

const breadcrumbs: Breadcrumb[] = [];

export function trackBreadcrumb(
  category: string,
  message: string,
  data?: Record<string, unknown>
): void {
  breadcrumbs.push({
    ts: new Date().toISOString(),
    category,
    message: truncate(message, 200),
    data: data ? sanitizeBreadcrumbData(data) : undefined,
  });

  if (breadcrumbs.length > MAX_BREADCRUMBS) {
    breadcrumbs.splice(0, breadcrumbs.length - MAX_BREADCRUMBS);
  }
}

export function getBreadcrumbsSnapshot(): Breadcrumb[] {
  return breadcrumbs.map((crumb) => ({ ...crumb }));
}

export function clearBreadcrumbsForTests(): void {
  breadcrumbs.length = 0;
}
